export default '/pricing/rbl';
